// extracted by mini-css-extract-plugin
export var dateTimeButton = "_df-1";
export var dateTimeButtonsContainer = "_df-6";
export var dateTimeInputContainer = "_df-7";
export var dateTimeWrapper = "_df-8";
export var disabledTile = "_df-0";
export var header = "_df-2";
export var line = "_df-3";
export var snoozeOption = "_df-4";
export var time = "_df-5";
export var todayTile = "_df-9";
export var wrapper = "_df-a";